export const splitClasses = classes => classes.join(' ');
